//app.require.js
//var angular = require('angular');
require('oclazyload');
// require('bootstrap');
// require("obtBower/bootstrap/dist/css/bootstrap.min.css");
// require("obtBower/bootstrap/dist/css/bootstrap-theme.min.css");


// require("css-loader?minimize!./file.css");

require('obtBower/bootstrap/dist/css/bootstrap.min.css');
require('obtBower/bootstrap/dist/css/bootstrap-theme.min.css');
require('obtBower/font-awesome/css/font-awesome.min.css');

require("obtBower/toastr/toastr.min.css");
require("obtBower/fullcalendar/dist/fullcalendar.min.css");
require("obtBower/angular-form-builder/dist/angular-form-builder.css");


require("obtBower/angular-wizard/dist/angular-wizard.min.css");
require("obtBower/angular-ui-switch/angular-ui-switch.css");

require("obtBower/ngCart/dist/ngCart.min.js");
require("obtBower/angular-upload/src/directives/btnUpload.min.css"); /* or .min.css */
require("obtBower/angular-upload/angular-upload.min.js");
require("obtBower/angular-youtube-mb/src/angular-youtube-embed.js");


require('obtNode/angular-loading-bar/build/loading-bar.min.css');
require('obtNode/angular-loading-bar/build/loading-bar.min.js');
require('obtNode/angular-recaptcha/release/angular-recaptcha.min.js');

require('obtNode/angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.css');
require('obtNode/angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.js');



require("obtStyle/AdminLTE.css"),
require("obtStyle/calendar.css"),
require("obtStyle/parallax2.css"),
require("obtStyle/recaptchaResponsive.css");
require("obtStyle/obt.css");
require("obtStyle/webpack_css_fix.css");
require("obtStyle/responsive_ul.css");
require("obtStyle/full-slider.css");

// require("obtStyle/skin-navy.css");
require("obtStyle/skin-grey.css");
require("obtStyle/skin-marianne.css");
require("obtStyle/skin-simplifystack-1.css");

require("./widgets/obtSection/obtSection.css");
require("./widgets/obtSection/same_col_height.css");

// require('obtStyle/skins/_all-skins.min.css');

require("obtBower/Ionicons/css/ionicons.min.css");
// app/widgets/obtSection/same_col_height.css

// require("css!obtStyle/AdminLTE.css"),
// require("css!obtStyle/calendar.css"),
// require("css!obtStyle/parallax.css"),
// require("css!obtStyle/recaptchaResponsive.css");

require("obtStyle/obt-skin.scss");


require('./blocks/blocks.require.js');
require('./core/core.require.js');
require('./data/data.require.js');
require('./widgets/widget.require.js');
require('./language/language.require.js');
require('./booking/booking.require.js');
require('./layout/layout.require.js');
require('./login/login.require.js');
 require('obtBower/angular-media-queries/match-media.js');

// require('obtBower/fullcalendar/dist/gcal.js');
// require('obtBower/fullcalendar/dist/lang/en-ca.js');
// require('obtBower/fullcalendar/dist/lang/fr-ca.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.require.js
 ** module id = 2
 ** module chunks = 0
 **/